/* =====================================================================
   BeezFy — Video in evidenza sulle card prodotto
   ---------------------------------------------------------------------
   Obiettivo: una collezione lunga piena di prodotti con video deve pesare
   quanto pesa oggi. Per questo il <video> NON sta nell'HTML: lo creo solo
   quando la card entra in vista e lo distruggo quando è lontana.

   Perché non basta scrivere <video preload="none" poster="...">:
   il poster viene scaricato SEMPRE e SUBITO (non esiste loading="lazy"
   sui poster). Su 60 card sarebbero 60 immagini in più al primo colpo.
   Qui il "poster" è già l'<img loading="lazy"> della card, che sta sotto.

   Doc: docs/VIDEO-IN-EVIDENZA.md
   ===================================================================== */
(function () {
  'use strict';

  var SEL = '[data-card-video]';
  var PLAY_RATIO = 0.5;   // quanto deve essere visibile per partire
  var MARGIN = '200px';   // quanto prima creare il player

  // ---- Quando NON far partire nulla (resta la foto, il video parte al tocco)
  function autoplayAllowed() {
    try {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
      var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (c) {
        if (c.saveData) return false;
        if (/(^|-)2g$/.test(c.effectiveType || '')) return false;
      }
    } catch (e) { /* in dubbio, si procede */ }
    return true;
  }

  function maxConcurrent() {
    var n = parseInt(document.documentElement.getAttribute('data-card-video-max'), 10);
    if (!n || n < 1) n = 2;
    return n;
  }

  var holders = [];        // { el, video, ratio }
  var byEl = new WeakMap();
  var allowAutoplay = autoplayAllowed();

  // La foto attualmente visibile nella card: in gallery è la slide attiva,
  // altrimenti l'immagine principale.
  function currentCardImage(layer) {
    var card = layer.closest ? layer.closest('[data-product-card]') : null;
    if (!card) return '';
    var img = card.querySelector('.bz-card__gallery-slide--active img')
           || card.querySelector('.bz-card__media-image--primary')
           || card.querySelector('.bz-card__media-image');
    if (!img) return '';
    return img.currentSrc || img.src || '';
  }

  function create(h) {
    if (h.video) return h.video;
    var v = document.createElement('video');

    // HLS quando il browser lo suona nativamente (Safari iOS/macOS e Android
    // recenti): è a banda adattiva, parte da un bitrate basso e sale solo se
    // serve. Altrove si ricade sull'mp4, che Liquid espone solo nella versione
    // più pesante — per questo il preload resta il vero freno.
    var hls = h.el.getAttribute('data-video-hls');
    var mp4 = h.el.getAttribute('data-video-src');
    var src = mp4;
    if (hls && v.canPlayType && v.canPlayType('application/vnd.apple.mpegurl')) src = hls;
    if (!src) return null;

    v.muted = true;            // obbligatorio per l'autoplay sui browser mobili
    v.defaultMuted = true;
    v.loop = true;
    v.playsInline = true;
    v.setAttribute('muted', '');
    v.setAttribute('playsinline', '');
    v.setAttribute('webkit-playsinline', '');
    v.setAttribute('disablepictureinpicture', '');
    v.setAttribute('disableremoteplayback', '');
    v.setAttribute('tabindex', '-1');
    v.preload = 'auto';        // creato solo quando serve: qui il preload va bene

    // Poster = la foto che la card sta GIA' mostrando. Senza, fra la comparsa
    // dell'elemento e il primo fotogramma decodificato si vede un lampo del
    // riquadro vuoto del player. L'immagine è già nella cache del browser:
    // non è una richiesta in più.
    var shown = currentCardImage(h.el);
    if (shown) v.poster = shown;

    v.src = src;

    // Ripiego per i browser senza requestVideoFrameCallback: 'playing' scatta
    // all'avvio della riproduzione, un filo prima del primo fotogramma.
    if (typeof v.requestVideoFrameCallback !== 'function') {
      v.addEventListener('playing', function () { h.el.classList.add('is-playing'); });
    }

    h.el.appendChild(v);
    h.video = v;
    return v;
  }

  function destroy(h) {
    if (!h.video) return;
    h.el.classList.remove('is-playing');
    try {
      h.video.pause();
      h.video.removeAttribute('src');
      h.video.load();          // libera il buffer invece di tenerlo in memoria
    } catch (e) { /* niente */ }
    if (h.video.parentNode) h.video.parentNode.removeChild(h.video);
    h.video = null;
  }

  function pause(h) {
    if (!h.video) return;
    h.el.classList.remove('is-playing');
    try { h.video.pause(); } catch (e) { /* niente */ }
  }

  function play(h) {
    var v = create(h);
    if (!v) return;
    var p = v.play();
    if (p && p.catch) p.catch(function () { /* autoplay negato: resta la foto */ });

    // La rivelazione va rifatta a OGNI ripresa, non solo alla creazione:
    // tornando sulla prima slide il video ripartiva ma restava invisibile.
    if (v.readyState >= 2) {
      h.el.classList.add('is-playing');
    } else if (typeof v.requestVideoFrameCallback === 'function') {
      v.requestVideoFrameCallback(function () { h.el.classList.add('is-playing'); });
    }
  }

  // Con più card in vista contemporaneamente non li faccio partire tutti:
  // solo i più vicini al centro dello schermo, gli altri restano sulla foto.
  function arbitrate() {
    if (!allowAutoplay || document.hidden) {
      holders.forEach(pause);
      return;
    }
    var cap = maxConcurrent();
    var center = window.innerHeight / 2;

    var candidates = holders.filter(function (h) { return h.ratio >= PLAY_RATIO && !h.offSlide; });
    candidates.forEach(function (h) {
      var r = h.el.getBoundingClientRect();
      h.distance = Math.abs(r.top + r.height / 2 - center);
    });
    candidates.sort(function (a, b) { return a.distance - b.distance; });

    var winners = candidates.slice(0, cap);
    holders.forEach(function (h) {
      if (winners.indexOf(h) === -1) pause(h);
    });
    winners.forEach(play);
  }

  // Lo strato video sta SOPRA le slide della card. Se l'utente sfoglia la
  // gallery, senza questo il video resterebbe davanti e sembrerebbe che la
  // gallery non scorra: qui si ritira (e si mette in pausa) appena si esce
  // dalla prima slide, e torna quando ci si rientra.
  function bindGallery(h) {
    var card = h.el.closest ? h.el.closest('[data-product-card]') : null;
    if (!card) return;
    var gal = card.querySelector('[data-card-gallery]');
    if (!gal) return;

    var onChange = function (index) {
      h.offSlide = index !== 0;
      if (h.offSlide) { pause(h); h.el.classList.remove('is-playing'); }
      arbitrate();
    };

    // l'evento del componente gallery non fa bubbling: si ascolta sul contenitore
    gal.addEventListener('gallery:change', function (e) {
      onChange((e && e.detail && e.detail.index) || 0);
    });

    // rete di sicurezza per i percorsi che non emettono l'evento (swipe, ecc.)
    if (window.MutationObserver) {
      var track = gal.querySelector('[data-gallery-track]') || gal;
      new MutationObserver(function () {
        var slides = gal.querySelectorAll('[data-gallery-slide]');
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].classList.contains('bz-card__gallery-slide--active')) { onChange(i); return; }
        }
      }).observe(track, { attributes: true, attributeFilter: ['class'], subtree: true });
    }
  }

  function observe(root) {
    var nodes = (root || document).querySelectorAll(SEL);
    if (!nodes.length) return;
    if (!('IntersectionObserver' in window)) return;   // niente IO: resta la foto

    Array.prototype.forEach.call(nodes, function (el) {
      if (byEl.has(el)) return;
      var h = { el: el, video: null, ratio: 0, distance: 0, offSlide: false };
      byEl.set(el, h);
      holders.push(h);
      io.observe(el);
      bindGallery(h);
    });
  }

  var io = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var h = byEl.get(entry.target);
          if (!h) return;
          h.ratio = entry.isIntersecting ? entry.intersectionRatio : 0;
          // fuori anche dal margine di cortesia: butto via il player
          if (!entry.isIntersecting) destroy(h);
        });
        arbitrate();
      }, { rootMargin: MARGIN, threshold: [0, PLAY_RATIO, 0.9] })
    : null;

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) holders.forEach(pause);
    else arbitrate();
  });

  // Tornando indietro dalla scheda prodotto la pagina viene ripresa dalla cache
  // del browser (bfcache): l'IntersectionObserver non riscatta perché nulla si è
  // mosso, e i video distrutti allo scroll non tornavano più. Qui rimisuro tutto.
  function recheck() {
    Array.prototype.forEach.call(roots(), function (el) {
      var h = byEl.get(el);
      if (!h) return;
      var r = el.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var visible = Math.min(r.bottom, vh) - Math.max(r.top, 0);
      h.ratio = r.height > 0 ? Math.max(0, visible) / r.height : 0;
    });
    arbitrate();
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) recheck(); });
  window.addEventListener('focus', recheck);

  function init() { observe(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Card aggiunte dopo (carica altri, filtri, quickview)
  document.addEventListener('beezfy:cards-rendered', function (e) {
    observe((e && e.detail && e.detail.container) || document);
  });
  if (window.MutationObserver) {
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { observe(document); return; }
      }
    });
    document.addEventListener('DOMContentLoaded', function () {
      mo.observe(document.body, { childList: true, subtree: true });
    });
  }
})();
